// @/app/components/TelegramCTA.tsx

interface TelegramCTAProps {
  label?: string;
  /**
   * Block-level surface for GA source_surface: where on the page this CTA
   * sits, not page identity (page comes from GA4 page_location).
   */
  placement?: string;
  className?: string;
}

const defaultPlacement = "article_header";
const defaultClasses = `
	    mt-6 inline-flex max-w-full items-center justify-center whitespace-normal text-center no-underline
	    rounded-full bg-[#1b7eae] px-6 py-3 text-base font-semibold text-white
	    shadow-md transition duration-300
	    hover:bg-[#1a77a3] hover:text-white hover:shadow-lg hover:no-underline
	    focus:outline-none focus-visible:ring-4 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white
	    active:bg-[#145f82] active:text-white active:shadow-lg
	  `;

export function TelegramCTA({
  label = "Join our Telegram study group",
  placement = defaultPlacement,
  className = defaultClasses,
}: TelegramCTAProps) {
  return (
    <a
      href="https://t.me/+1zykXhyQ5cgwNDQ9"
      target="_blank"
      rel="noopener noreferrer"
      className={className ?? ""}
      data-nosnippet
      data-ga-event="telegram_click"
      data-ga-category="CTA"
      data-ga-journey="shared_telegram_cta"
      data-ga-source-surface={placement ?? undefined}
      data-ga-target-stage="community"
      data-ga-target-type="channel"
      data-ga-target-id="telegram_study_group"
      data-ga-cta-family="community_cta"
      data-ga-commercial-intent="nurture"
      data-ga-primary="false"
    >
      {label}
    </a>
  );
}
